import { apiWithProject } from './greenetworkAPI';
import createRequestQueue from '@/utils/requestQueue';

const END_POINT = '/devices';

const NOT_FOUND = null

const addDevice = (id, displayName) => apiWithProject.post(`${END_POINT}/${id}`, {
  class: 'Meter',
  displayName,
  function: 'Basic',
});

const updateDisplayName = (id, displayName) => apiWithProject.put(`${END_POINT}/${id}`, {
    function: 'Basic',
    class: 'Meter',
    data: {
      assetId: id,
      displayName,
    },
  },
);

const updateRateInfo = (id, rateType, rateRegion) => apiWithProject.put(`${END_POINT}/${id}`, {
    function: 'RateParameters',
    class: 'Meter',
    data: {
      rateRegion,
      rateType
    }
  },
);

const deletion = (id) => apiWithProject.delete(`${END_POINT}/${id}`);

const functionData = (id) => apiWithProject.get(`${END_POINT}/${id}/functions/ElectricMeter`);

const getLastRead = async (id) => {
  try {
    return await apiWithProject.get(`${END_POINT}/${id}`);
  } catch {
    return NOT_FOUND;
  }
};

const reqData = (id, start, end) => {
  return apiWithProject.get(`${END_POINT}/${id}/functions/ElectricMeter/measurements?since=${start}&until=${end}`);
}

const summaryData = (id, type, requestBody, timezone) => {
  return apiWithProject.get(`${END_POINT}/${id}/functions/ElectricMeter/measurements/summary/${type}?${requestBody}&timezone=${timezone}`);
}
// Cada medidor puede traer `sign` (v1.22.0, restar un submedidor): va
// atado a su propia respuesta, no a su posición, porque un medidor que
// falla se cae del arreglo y correr por índice desalinearía signo y dato.
const multiSummaryData = async (meters, type, milis, timezone, options = {}) => {
  const queue = options.queue || createRequestQueue();
  const requests = meters.map((meter) =>
    queue.run(JSON.stringify(['energy', options.project, meter.id, type, milis, timezone]), () =>
      apiWithProject.get(`${END_POINT}/${meter.id}/functions/ElectricMeter/measurements/summary/${type}?start=${milis}&timezone=${timezone}`), options.isCurrent)
      .then((response) => ({ sign: meter.sign ?? 1, data: response?.data || [] }))
      .catch((error) => ({ sign: meter.sign ?? 1, data: [], error }))
  );
  const results = await Promise.all(requests);
  return results;
}

const MeterGreen = {
  addDevice, updateDisplayName, updateRateInfo, functionData, getLastRead, reqData, summaryData, deletion, multiSummaryData
};

export default MeterGreen;
